import React from 'react';
import Layout from "@/locales/en/layout/Layout";
import {useQuery} from "react-query";
import {getAnnouncementsId, imgUrl} from "../../../api/general";
import {NewsIdWrapperElon} from "../../../components/news/NewsPageWrapper";
import CustomTitle from "../../../components/custom_title";
import {Swiper, SwiperSlide} from "swiper/react";
import {useTranslation} from "react-i18next";

function Edu(props) {
    const { t } = useTranslation();

    const { data } = useQuery({
        queryKey: ["AnnouncementsId", 779],
        queryFn: () => getAnnouncementsId(779),
    });
    console.log(data)
    return (
        <Layout>
            <div className="container" style={{marginTop: 100}}>
                <iframe width="100%" height="600" src="https://www.youtube.com/embed/B9moZaHLUr8"
                        title="Kredit-modul tizimida qayta o&#39;qish uchun kontrakt.edu.uz da shartnoma olish bo&#39;yicha yo&#39;riqnoma"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen></iframe>
            </div>
            <NewsIdWrapperElon>
                <div className="container  mt-lg-5 mt-3">
                    <div className="content-news">
                        <div className="d-flex gap-3">
                            <img className="fotoGlavni" src={imgUrl + data?.data?.data?.img} alt="img"/>
                            <div className="text1" >{data?.data?.data?.title}</div>
                        </div>
                    </div>


                    <p dangerouslySetInnerHTML={{ __html: data?.data?.data?.text1 }} />
                </div>
                <CustomTitle name={t("lavhalar")} my={true} />
            </NewsIdWrapperElon>


        </Layout>
    );
}

export default Edu;